<template>
  <div class="addActivities">
    <div class="main">
      <el-form ref="forms" :model="form" label-width="160px" :rules="rules">
        <el-form-item label="banner名称" prop="name">
          <el-input v-model="form.name" placeholder="banner名称"></el-input>
        </el-form-item>

        <el-form-item label="酒吧id" prop="barId">
          <el-input v-model="form.barId" placeholder="酒吧id"></el-input>
        </el-form-item>

        <el-form-item label="banner链接" prop="linkUrl">
          <el-input v-model="form.linkUrl" placeholder="banner链接"></el-input>
        </el-form-item>

        
            <el-form-item label="appId">
          <el-input v-model="form.appId" placeholder="appId"></el-input>
        </el-form-item>

        <el-form-item
          label="banner跳转类型"
          label-position="right"
          class="form-label"
          prop="type"
        >
          <el-select v-model="form.type" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="活动时间" prop="activityTime">
          <el-date-picker
            v-model="form.activityTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="banner图片" prop="url">
          <el-upload
            class="avatar-uploader"
            :action="imgURL"
            :show-file-list="false"
            :on-success="handleSuccess"
          >
            <img
              style="width: 100px; height: 100px"
              v-if="form.url"
              :src="form.url"
              class="avatar"
            />
            <i
              style="width: 100px; height: 100px"
              v-else
              class="el-icon-plus avatar-uploader-icon"
            ></i>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn">
      <el-button type="success" @click="submit('forms')">提交</el-button>
    </div>
  </div>
</template>

<script>
import { IP, updateBanner, bannerDetail } from "@/api/api";
import reg from "@/utils/reg.js";
import moment from "moment";
export default {
  data() {
    const self = this;
    return {
      // 图片上传地址
      imgURL: IP + "/images/uploadImage",
      // imgURL: IP + "/obs/uploadImage",
      form: {
        name: "",
        barId: "",
        linkUrl: "",
        url: "",
        type: "",
        startTime: "",
        endTime: "",
        bannerId: "",
        activityTime: "",
        appId:"",
      },
      options: [
        {
          value: 1,
          label: "酒吧跳转",
        },
        {
          value: 2,
          label: "链接跳转",
        },
        {
          value: 3,
          label: "小程序跳转",
        },
        {
          value: 4,
          label: "跳转会员页",
        },
      ],
      rules: {
        //验证规则
        name: [
          { required: true, message: "请输入轮播图名称", trigger: "blur" },
        ],
        activityTime: [
          { required: true, message: "请选择轮播图时间", trigger: "blur" },
        ],
        barId: [{ required: true, message: "请输入酒吧id", trigger: "blur" }],
        linkUrl: [
          {
            required: true,
            message: "请输入链接地址，没有则填无",
            trigger: "blur",
          },
        ],
        type: [
          { required: true, message: "请选择轮播图跳转类型", trigger: "blur" },
        ],
        url: [{ required: true, message: "请输入轮播图封面", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    //  获取banner详情
    async getDetail() {
      let res = await bannerDetail({
        id: this.$route.query.bannerId,
      });
      res.data.activityTime = ["", ""];
      res.data.activityTime[0] = new Date(res.data.startTime);
      res.data.activityTime[1] = new Date(res.data.endTime);
      this.form.bannerId = this.$route.query.bannerId;
      this.form.name = res.data.name; //
      this.form.barId = res.data.barId; //
      (this.form.url = res.data.url),
        (this.form.startTime = res.data.startTime);
      this.form.endTime = res.data.endTime;
      this.form.type = res.data.type;
      this.form.linkUrl = res.data.linkUrl;
      this.form.activityTime = res.data.activityTime;
      this.form.appId=res.data.appId;
    },

    submit(formName) {
      (this.form.startTime = moment(this.form.activityTime[0]).format(
        "YYYY-MM-DD"
      )),
        (this.form.endTime = moment(this.form.activityTime[1]).format(
          "YYYY-MM-DD"
        ));
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await updateBanner({
            id: this.form.bannerId,
            name: this.form.name,
            url: this.form.url,
            linkUrl: this.form.linkUrl,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            type: this.form.type,
            barId: this.form.barId,
            appId:this.form.appId,
          });
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功",
            });
            this.$router.push("banner");
          }
        } else {
          return false;
        }
      });
    },

    handleSuccess(response, file, fileList) {
      console.log(response);
      this.form.url = response;
    },
  },
};
</script>

<style lang="less" scoped>
.addActivities {
  background: #fff;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
  overflow-y: scroll;
}
.btn {
  padding: 0 150px;
}
/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
/deep/ .avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>